export default () => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  selector: { flex: 1 },
  pendingChanges: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    fontSize: '18px',
    color: 'white',
  },
  textField: {
    marginRight: 4,
    maxWidth: 200,
  },
  searchInput: {
    backgroundColor: 'white',
    paddingLeft: 6,
  },
});
